import React from "react";
import {COLORWAY_CODES, COLORWAY_DATA} from "../../../../../core/constants/color";
import ColorOption from "./ColorOption";
import {useSelector} from "react-redux";


const ColorwayPreview = ({
  keyColorItem,
  secondaryColorItem,
  thirdColorItem,
  stepObject,
  navigationDataObject,
  slideToSubHandler
                          }) => {

  const sendData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const currentColorway = sendData?.COLORWAY;
  // const title = COLORWAY_DATA.find(item => item.colorwayCode === currentColorway)?.title;

  const title = COLORWAY_DATA[currentColorway]?.title;

  return (
    <div className={"colorway-preview"}>
      {/* Key Color with Header */}
      <ColorOption
        code={"INT_KEY"}
        colorItemObject={keyColorItem}
        navigationDataObject={navigationDataObject}
        stepObject={stepObject}
        slideToSubHandler={slideToSubHandler}
        targetDepth="2"
        showHeader={true}
        headerTitle={title}
        visible={true}
        disableOptionClick={true}
      />

      {/* Secondary Color */}
      <ColorOption
        code={"INT_SECONDARY"}
        colorItemObject={secondaryColorItem}
        navigationDataObject={navigationDataObject}
        stepObject={stepObject}
        slideToSubHandler={slideToSubHandler}
        targetDepth="2"
        visible={currentColorway !== COLORWAY_CODES.SINGLE}
        disableOptionClick={true}
      />

      {/* Third Color */}
      <ColorOption
        code={"INT_THIRD"}
        colorItemObject={thirdColorItem}
        navigationDataObject={navigationDataObject}
        stepObject={stepObject}
        slideToSubHandler={slideToSubHandler}
        targetDepth="2"
        visible={currentColorway === COLORWAY_CODES.REAR_HIGHLIGHT}
        disableOptionClick={true}
      />
    </div>
  );
}

export default ColorwayPreview;
